import { useReducer } from "react";
import { toast } from "react-toastify";
import {
  firestore,
  timestamp,
  agregarArray,
  quitarArray,
} from "../../firebase/utiles";
import MenuContext from "./MenuContext";
import MenuReducer from "./MenuReducer";
import {
  OBTENER_MENUS,
  CREAR_NUEVO_MENU,
  PREPARAR_NUEVO_MENU,
  LIMPIAR_ESTADO_MENUS,
} from "../types";

const MenuState = ({ children }) => {
  const initialState = {
    menus: [],
    menu: null,
    creando: false,
  };

  const [state, dispatch] = useReducer(MenuReducer, initialState);

  // obtener todos los menus
  const obtenerMenus = () => {
    firestore
      .collection("menus")
      .orderBy("fecha", "asc")
      .onSnapshot((snap) => {
        const docs = [];
        snap.forEach((doc) => {
          docs.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        dispatch({
          type: OBTENER_MENUS,
          payload: docs,
        });
      });
  };

  // obtener menus publicados
  const obtenerMenusPublicados = () => {
    firestore
      .collection("menus")
      .where("publicado", "==", true)
      .orderBy("fecha", "asc")
      .onSnapshot((snap) => {
        const docs = [];
        snap.forEach((doc) => {
          docs.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        dispatch({
          type: OBTENER_MENUS,
          payload: docs,
        });
      });
  };

  // crear nuevo menu
  const crearMenu = (data) => {
    const creado = timestamp();
    const creador = {
      nombre: data.usuario.nombre,
      id: data.usuario.id,
    };
    const fecha = data.fecha;
    const plato = {
      id: data.plato.id,
      imagenUrl: data.plato.imagenUrl,
      nombre: data.plato.nombre,
      descripcion: data.plato.descripcion,
      precio: data.plato.precio,
    };
    const pedidos = [];
    const publicado = true;

    firestore.collection("menus").add({
      fecha,
      plato,
      pedidos,
      publicado,
      creado,
      creador,
    });

    dispatch({
      type: CREAR_NUEVO_MENU,
    });
    toast.success("Menú creado con exito");
  };

  // listar o no listar el menu
  const estadoPublicado = (id) => {
    firestore
      .collection("menus")
      .doc(id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          return doc.ref.update({ publicado: !doc.data() });
        }
      });
  };

  // eliminar menu
  const eliminarMenu = (data) => {
    firestore.collection("menus").doc(data.id).delete();
    toast.success("Menú eliminado con exito");
  };

  // preparar para crear otro menu
  const prepararNuevoMenu = () => {
    dispatch({
      type: PREPARAR_NUEVO_MENU,
    });
  };

  // limpiar el estado del contexto de menus
  const limpiarEstadoMenus = () => {
    dispatch({
      type: LIMPIAR_ESTADO_MENUS,
    });
  };

  // hacer pedidos
  const hacerPedido = (data) => {
    const cliente = {
      nombre: data.usuario.nombre,
      id: data.usuario.id,
      cell: data.usuario.celular,
      correo: data.usuario.correo,
    };
    const menuId = data.menu.id;

    // agregar el cliente al arreglo de pedidos
    firestore
      .collection("menus")
      .doc(menuId)
      .update({
        pedidos: agregarArray({
          cliente,
        }),
      })
      .then(() => {
        toast.success("Reserva de menú realizada con exito");
      })
      .catch((err) => {
        toast.error(
          "Este menú ya fue reservado, puede intentar reservar otro."
        );
      });
  };

  // cancelar pedidos
  const cancelarPedido = (data) => {
    const cliente = {
      nombre: data.usuario.nombre,
      id: data.usuario.id,
      cell: data.usuario.celular,
      correo: data.usuario.correo,
    };
    const menuId = data.menu.id;

    // quitar el cliente al arreglo de pedidos
    firestore
      .collection("menus")
      .doc(menuId)
      .update({
        pedidos: quitarArray({
          cliente,
        }),
      })
      .then(() => {
        toast.info("Reserva de menú cancelada con exito");
      });
  };

  return (
    <MenuContext.Provider
      value={{
        menus: state.menus,
        menu: state.menu,
        creando: state.creando,
        obtenerMenus,
        obtenerMenusPublicados,
        crearMenu,
        eliminarMenu,
        prepararNuevoMenu,
        limpiarEstadoMenus,
        hacerPedido,
        cancelarPedido,
        estadoPublicado,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
};

export default MenuState;
